import { forwardRef } from 'react'
import { Input as AntInput, InputProps, InputRef } from 'antd'
import { TextAreaProps as AndTextAreaProps } from 'antd/lib/input'
import cl from 'classnames'

import styles from './styles.module.scss'

const { TextArea: AntTextArea } = AntInput

type TextAreaProps = InputProps & AndTextAreaProps & { isReadOnly?: boolean }

const TextArea = forwardRef<InputRef, TextAreaProps>(
	({ className, disabled, isReadOnly, ...props }, ref) => {
		return (
			<AntTextArea
				{...props}
				className={cl(styles.textArea, className, {
					[styles.isReadOnly]: isReadOnly
				})}
				ref={ref}
				autoComplete="off"
				disabled={disabled || isReadOnly}
			/>
		)
	}
)

export default TextArea
